module.exports = __webpack_public_path__ + "img/colorMap_8192_compressed.ffda0d8b.jpg";